// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const foodNutritionalFormatId = (z.number());
export const foodNutritionalFormat = z.object({
    id: foodNutritionalFormatId,
    name: z.string(),
    deleted_at: z.date().nullable(),
    description: z.string().nullable(),
    created_at: z.date(),
    requires_serving_size: z.boolean(),
    deleted_by: operatorId.nullable(),
});
export const foodNutritionalFormatInitializer = z.object({
    id: foodNutritionalFormatId.optional(),
    name: z.string(),
    deleted_at: z.date().optional().nullable(),
    description: z.string().optional().nullable(),
    created_at: z.date().optional(),
    requires_serving_size: z.boolean().optional(),
    deleted_by: operatorId.optional().nullable(),
});
export const foodNutritionalFormatMutator = z.object({
    id: foodNutritionalFormatId.optional(),
    name: z.string().optional(),
    deleted_at: z.date().optional().nullable(),
    description: z.string().optional().nullable(),
    created_at: z.date().optional(),
    requires_serving_size: z.boolean().optional(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FoodNutritionalFormat.js.map